import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { LandingPage } from '../components';
import { apiCallIds } from '../api';
import { subscribeActions } from '../ducks';
import { Redirect } from 'react-router';

let baseWeb = process.env.REACT_APP_HOMEPAGE_FOLDER

const mapStateToProps = state => ({
  isSubscribing: selectIsInProgress(state, apiCallIds.NEWSLETTER_SUBSCRIBE),
});

const mapDispatchToProps = dispatch => ({
  goToCalculatorCreditor: path => dispatch(push('onboarding/creditor')),
  goToCalculatorDebtor: path => dispatch(push('onboarding/debtor')),
  actions: bindActionCreators(
    {
      subscribe: subscribeActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class LandingPageContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    goToCalculatorCreditor: PropTypes.func.isRequired,
    goToCalculatorDebtor: PropTypes.func.isRequired,
    isSubscribing: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    localStorage.setItem('utm_source', this.props.location.query.utm_source);
    localStorage.setItem('utm_medium', this.props.location.query.utm_medium);
    localStorage.setItem('utm_campaign', this.props.location.query.utm_campaign);
    window.location.href = '/' + baseWeb + '/#/auth/login'
  }

  submitNewsletter = email => {
    this.props.actions.subscribe({ email });
  };

  render() {
    const { goToCalculatorCreditor, goToCalculatorDebtor, isSubscribing } = this.props;

    return (
      // <LandingPage
      //   goToCalculatorCreditor={goToCalculatorCreditor}
      //   goToCalculatorDebtor={goToCalculatorDebtor}
      //   isSubscribing={isSubscribing}
      //   submitNewsletter={this.submitNewsletter}
      // />
      null
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/landing-page/containers/LandingPageContainer.js